import { orderBy as SortBy } from 'lodash'
import { JOB_PUBLIC_STATUS } from 'helpers'
import { Job } from 'ducks/types'
import { JobsIndicators } from './types'
import { Stat } from 'ducks/config/types'
import { getTypedState } from 'ducks/hooks'

export const getJobs = (
  orderBy?: string,
  order?: 'asc' | 'desc',
  status?: JOB_PUBLIC_STATUS
) => (): Job[] => {
  const { jobs } = getTypedState()
  if (!jobs || !jobs.length) return []
  if (status) return jobs.filter(jobs => jobs.publicStatus === status) || []
  if (orderBy && order) return SortBy(jobs, orderBy, order) as Job[]
  return jobs
}

export const getJobsIndicators = () => (): JobsIndicators => {
  const { config: { jobPagination, jobStats } } = getTypedState()

  if (!jobPagination || !jobStats) {
    return { total: 0, upcoming: 0, inProgress: 0, attention: 0, completed: 0 }
  }

  return {
    total: jobPagination?.total ?? 0,
    upcoming:
      (jobStats.find((stat: Stat) => stat.status === 'Scheduling')?.count ?? 0) +
      (jobStats.find((stat: Stat) => stat.status === 'Dispatched')?.count ?? 0) +
      (jobStats.find((stat: Stat) => stat.status === 'Hold')?.count ?? 0),
    inProgress: jobStats.find((stat: Stat) => stat.status === 'In Progress')?.count ?? 0,
    attention: jobStats.find((stat: Stat) => stat.status === 'Needs Attention')?.count ?? 0,
    completed: jobStats.find((stat: Stat) => stat.status === 'Completed')?.count ?? 0
  }
}
